export interface BusinessGoal {
  revenue: number;
  revenueGoal: number;
  conversions: number;
  conversionGoal: number;
  costPer: number;
  costPerGoal: number;
}

export const exampleBusinessGoal: BusinessGoal = {
  revenue: 2000.0,
  revenueGoal: 1000.0,
  conversions: 100,
  conversionGoal: 50,
  costPer: 5.0,
  costPerGoal: 7.5,
};

export interface DataActivity {
  status: 'old' | '72h' | '48h' | '24h';
  timestamp: number | null;
}

export const exampleDataActivity: DataActivity = {
  status: 'old',
  timestamp: null,
};

export interface BusinessKPIGoals {
  icon: string;
  name: string;
  estimate: boolean;
  date_range: BusinessGoal;
}

export const exampleBusinessKPIGoals: BusinessKPIGoals = {
  estimate: false,
  icon: 'fa fa-usd-square',
  name: 'Leads',
  date_range: exampleBusinessGoal,
};

export type BusinessKPISuccess = {
  businessID: number;
  internalKPI: {
    goals: BusinessKPIGoals;
    phase: string;
    adSpend: number;
    customers: number;
    fbPixel: DataActivity;
    fbUpload: DataActivity;
    returnOnInvestment: number;
    returnOnPhaseInvestment: number;
  };
  externalKPI: {
    reach?: number;
    frequency?: number;
  };
  error: null;
};

export type BusinessKPIFailure = {
  businessID: number;
  internalKPI: null;
  externalKPI: null;
  error: string;
};

export type BusinessKPI = BusinessKPISuccess | BusinessKPIFailure;

export const exampleBusinessKPI: BusinessKPI = {
  businessID: 1,
  internalKPI: {
    goals: exampleBusinessKPIGoals,
    phase: 'Fly',
    adSpend: 1,
    customers: 4,
    returnOnInvestment: 0,
    returnOnPhaseInvestment: 0,
    fbPixel: exampleDataActivity,
    fbUpload: exampleDataActivity,
  },
  externalKPI: {
    reach: 6,
    frequency: 7,
  },
  error: null,
};

export const exampleFailedBusinessKPI: BusinessKPI = {
  businessID: 1,
  internalKPI: null,
  externalKPI: null,
  error: 'Some error message',
};
